// extracted by mini-css-extract-plugin
module.exports = {"days":"fh","additionalInfo":"fi","hidden":"fj","centerMenu":"fk","logo":"fl","social":"fm","socialLink":"fn"};